import { render, staticRenderFns } from "./shipper_set.vue?vue&type=template&id=1414c282&scoped=true&"
import script from "./shipper_set.vue?vue&type=script&lang=js&"
export * from "./shipper_set.vue?vue&type=script&lang=js&"
import style0 from "./shipper_set.vue?vue&type=style&index=0&id=1414c282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414c282",
  null
  
)

export default component.exports